var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { gqlSdk } from '@cta-portal/webapp-common/lib/api/client';
function isUsernameCharactersOk(username) {
    var regex = /^(?!-)(?!.*--)[\dA-Za-z-]{3,16}(?<!-)$/;
    return regex.test(username);
}
export function checkUsername(username_1, t_1) {
    return __awaiter(this, arguments, Promise, function (username, t, needsAvailabilityCheck) {
        var errorMessage, availableUsernameResponse;
        if (needsAvailabilityCheck === void 0) { needsAvailabilityCheck = false; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (username.length === 0)
                        return [2 /*return*/, errorMessage];
                    if (!(username.length < 3)) return [3 /*break*/, 1];
                    errorMessage = t('error.username-too-short') || '';
                    return [3 /*break*/, 6];
                case 1:
                    if (!(username.length > 16)) return [3 /*break*/, 2];
                    errorMessage = t('error.username-too-long') || '';
                    return [3 /*break*/, 6];
                case 2:
                    if (!isUsernameCharactersOk(username)) return [3 /*break*/, 5];
                    if (!needsAvailabilityCheck) return [3 /*break*/, 4];
                    return [4 /*yield*/, gqlSdk.UserIsUsernameAvailable({ input: { username: username } })];
                case 3:
                    availableUsernameResponse = _a.sent();
                    if (!availableUsernameResponse.userIsUsernameAvailable.available) {
                        errorMessage = t('error.username-already-taken') || '';
                    }
                    _a.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    errorMessage = t('error.username-characters-not-allowed') || '';
                    _a.label = 6;
                case 6: return [2 /*return*/, errorMessage];
            }
        });
    });
}
export function checkPassword(password, t) {
    var passwordErrorMessage;
    if (password.length < 8) {
        passwordErrorMessage = t('error.password-too-short') || '';
    }
    else if (password.length > 255) {
        passwordErrorMessage = t('error.password-too-long') || '';
    }
    return passwordErrorMessage;
}
